import axios from "axios";

// Load from environment
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const VIDEO_STREAM_URL = process.env.REACT_APP_VIDEO_STREAM_URL;

export default axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});
